// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3ciBd","DesktopOnly":"Toolbar_DesktopOnly__UjU69","Logo":"Toolbar_Logo__10N0b"};